<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="750"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        color="secondary"
        depressed
        tile
        v-bind="attrs"
        v-on="on"
      >
        Export
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        Export Options
      </v-card-title>
      <v-card-text>
        What type of export would you like?
        <v-list>
          <v-list-item-group v-model="exportType">
            <span
              v-if="error"
              class="error--text"
            >{{ errorMessage }}</span>
            <v-list-item>
              <template #default="{ active }">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    color="primary"
                    hide-details="auto"
                    :error="error"
                  />
                </v-list-item-action>
                <v-list-item-title>Just this page</v-list-item-title>
              </template>
            </v-list-item>
            <v-list-item>
              <template #default="{ active }">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    color="primary"
                    hide-details="auto"
                    :error="error"
                  />
                </v-list-item-action>
                <v-list-item-title>All  entries matching the provided filters</v-list-item-title>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          depressed
          tile
          color="grey"
          class="white--text"
          @click="closeModal()"
        >
          Cancel
        </v-btn>
        <v-btn
          depressed
          tile
          color="tertiary"
          class="white--text"
          :disabled="noOptionSelected"
          @click="confirmExport()"
        >
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      exportType: null,
      error: false
    }
  },
  computed: {
    errorMessage() {
      if (!this.error) {
        return null
      }

      return 'Please pick an option'
    },
    noOptionSelected() {
      return !this.exportType && this.exportType !== 0
    }
  },
  methods: {
    downloadExport() {
      let type
      switch (this.exportType) {
        case 0:
          type = 'page'
          break
        case 1:
          type = 'all'
          break
        default:
          break
      }
      this.$emit('download-export', type)
    },
    confirmExport() {
      this.error = false
      if (!this.exportType && this.exportType !== 0) {
        this.error = true
        return
      }
      this.downloadExport()
      this.closeModal()
    },
    closeModal() {
      this.dialog = false
      this.exportType = null
      this.error = false
    }
  }
}
</script>
